import React, { useRef, useState, useEffect } from 'react';
import { useAsyncDebounce } from 'react-table';
import { useTableInstance } from '../TableContext/TableContext.esm.js';
import '../TableContext/TableProvider.esm.js';
import { TableFilter } from './TableFilter.esm.js';

/**
 * Filters the table data locally that matches the string entered in the Search input.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { ConnectedTable, ConnectedTableFilter, TableFilter, TableProvider } from "@panwds/react-table";
 * ```
 */
var ConnectedTableFilter = function (_a) {
    var placeholder = _a.placeholder;
    var _b = useTableInstance(), autoResetGlobalFilter = _b.autoResetGlobalFilter, data = _b.data, setGlobalFilter = _b.setGlobalFilter, _c = _b.state.globalFilter, globalFilter = _c === void 0 ? "" : _c;
    var componentMounted = useRef(false);
    var _d = useState(globalFilter), value = _d[0], setLocalValue = _d[1];
    var setGlobalValue = useAsyncDebounce(function (v) {
        setGlobalFilter(v);
    }, 200);
    useEffect(function () {
        if (!componentMounted.current) {
            componentMounted.current = true;
        }
        else if (autoResetGlobalFilter) {
            setLocalValue("");
            setGlobalFilter("");
        }
    }, [autoResetGlobalFilter, data]);
    return (React.createElement(TableFilter, { onChange: function (e) {
            var v = e.currentTarget.value;
            setLocalValue(v);
            setGlobalValue(v);
        }, placeholder: placeholder, value: value }));
};

export { ConnectedTableFilter };
//# sourceMappingURL=ConnectedTableFilter.esm.js.map
